// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_b98283d4","p":"_c4d44e97","icon":"_310371ec"};